module.exports = __webpack_public_path__ + "static/media/tile-variant-calling.62cb2aa7.svg";